import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CloudSync } from "@mui/icons-material";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';


import Service from "../../../util/Service";
import { Checkbox, ListItemButton, ListItemIcon } from "@mui/material";


export default function KanbanSyncRedmine(props) {
    const { kanban, action } = props;
    const [open, setOpen] = React.useState(false);
    const [tarefas, setTarefas] = React.useState([]);
    const [checked, setChecked] = React.useState([]);

    React.useEffect(() => {
        if (open) {
            buscarIssues();
        }
    }, [open])

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const buscarIssues = () => {
        Service.GET("/api/security/integration/redmine/project/issues/" + kanban.idProjeto).then(r => {
            if(r && r.issues.length > 0){
                setTarefas(r.issues);
            }
        })
    }
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
    const handleTodas=()=>{
        console.log( tarefas);
        // console.log( checked );
        const issues = []
        for(const i of tarefas){
            issues.push(i.id);
        }
        const dado = {
            idKanban: kanban.id,
            issues: issues
        }
        console.log( dado);
        Service.POST('/api/security/projeto/kanban/cards/criarFromRedmine', dado).then(r => {
            if (r.success) {
                console.log( r );
                setOpen(false);
                if(action)action(r);
            } else {
                alert(r.msg);
            }
        })
    }

    return (
        <React.Fragment>
            <Button startIcon={<CloudSync />} size='small'
                onClick={handleClickOpen}
            >
                Redmine Sync
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Sincroniar com as atividades do Redmine
                </DialogTitle>
                <DialogContent>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        {tarefas && tarefas.length> 0 && tarefas.map((row, id) =>(
                            <React.Fragment key={id}>
                                <ListItem alignItems="flex-start" disablePadding>
                                    <ListItemButton role={undefined} onClick={handleToggle(row.id)} dense>
                                        <ListItemIcon>
                                            <Checkbox
                                            edge="start"
                                            checked={checked.includes(row.id)}
                                            tabIndex={-1}
                                            disableRipple
                                            // inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={row.subject}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography
                                                        component="span"
                                                        variant="body2"
                                                        sx={{ color: 'text.primary', display: 'inline' }}
                                                    >
                                                        {formataData(row.created_on)}
                                                    </Typography>
                                                    {" — "+row.description}
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </React.Fragment>
                        ))}
                        
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Fechar</Button>
                    <Button onClick={handleClose}>Escolhidas</Button>
                    <Button onClick={handleTodas} autoFocus>
                        Todas
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
